export default {
	data() {
		return {
			moduleName: 'localities',
			detailPageRouteName: 'localitiesDetail',
			updateFields: [
				'name',
				'description',
				'loadbalanced_localities',
				'failover_localities',
				'maintenance',
				'default',
				'country_code',
			],
			newFields: [
				'name',
				'description',
				'id_operator',
				'loadbalanced_localities',
				'failover_localities',
				'maintenance',
				'default',
				'country_code',
			],
		}
	},
	methods: {
		filterFormParams(params, isUpdate = false) {
			let fields = isUpdate? this.updateFields : this.newFields;
			let allowed = {}
			this._.forOwn(params, function (value, key) {
				if (fields.includes(key)) {
					allowed[key] = value
				}
			}.bind(this))
			return allowed
		},
		executePopupAction(value) {
			if (value === true) {
				if (this.getPopupAction === 'delete-ip-prefix') {
					this.deleteIpPrefix(this.getPopupId, false);
				} else if (this.getPopupAction === 'delete-content-source') {
					this.deleteContentSource(this.getPopupId, false);
				}else if(this.getPopupAction === 'delete-entity'){
					this.deleteEntity(false);
				}
			}
			this.hidePopup();
		},
		getEntity() {
			this.setLoadingMessage();

			return this.entityService.getEntity(this.$route.params.id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
				.then(data => {
					this.entity = data.locality;
					this.emptyMessage();
				})
				.then(() => {
					this.$refs['localitydetailformref'].initLocalities();
				})
				.catch(function (error) {
					this.setErrorMessage(error['error_message']);
				}.bind(this));
		},
		updateEntity(params, redirect = false) {
			this.entityService.updateEntity(this.entity.id, this.filterFormParams({...params}, true))
				.then(() => {
					if (redirect === true) {
						this.redirect(this.moduleName);
					} else {
						this.emptyMessage();
						this.setSuccessMessage();
						this.getEntity();
					}
				})
				.catch(function (error) {
					this.setErrorMessage(this.processErrorMessage(error));
				}.bind(this));
		},
		deleteEntity(showPopup = true){
			if (showPopup) {
				this.showPopup(this.entity.id, 'delete', 'delete-entity');
			} else {
				this.entityService.deleteEntity(this.entity.id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
					.then(() => {
						this.emptyMessage();
						this.setSuccessMessage();
						this.$router.push({name: this.moduleName})
					})
					.catch(function (error) {
						this.setErrorMessage(this.processErrorMessage(error));
					}.bind(this));
			}
		},
		reloadEntity(){
			this.getEntity();
		},
		updateIpPrefix(idIpPrefix, newIpPrefix) {
			this.entityService.updateIpPrefixInLocality({id_locality: this.localityId, id_ip_prefix: idIpPrefix, new_ip_prefix: newIpPrefix})
				.then(() => {
					this.emptyMessage();
					this.setSuccessMessage();
					this.$emit('reload-entity');
				})
				.catch(function (error) {
					this.setErrorMessage(this.processErrorMessage(error));
				}.bind(this));
		},
		deleteIpPrefix(ip_prefixes, showPopup = true) {
			if (showPopup) {
				this.showPopup(ip_prefixes, 'delete', 'delete-ip-prefix');
			} else {
				this.entityService.deleteIpPrefixFromLocality({id_locality: this.localityId, ip_prefixes: ip_prefixes})
					.then(() => {
						this.emptyMessage();
						this.setSuccessMessage();
						this.$emit('reload-entity');
					})
					.catch(function (error) {
						this.setErrorMessage(this.processErrorMessage(error));
					}.bind(this));
			}
		},
		addContentSource(){
			this.entityService.addContentSourceToLocality(this.newContentSource)
				.then(() => {
					this.emptyMessage();
					this.setSuccessMessage();
					this.$emit('reload-entity');
					this.toggleNewContentSource()
				})
				.catch(function (error) {
					this.setErrorMessage(this.processErrorMessage(error));
				}.bind(this));
		},
		deleteContentSource(idContentSource, showPopup = true) {
			if (showPopup) {
				this.showPopup(idContentSource, 'delete', 'delete-content-source');
			} else {
				this.entityService.deleteContentSourceFromLocality({id_locality: this.locality.id, id_content_source: idContentSource})
					.then(() => {
						this.emptyMessage();
						this.setSuccessMessage();
						this.$emit('reload-entity');
					})
					.catch(function (error) {
						this.setErrorMessage(this.processErrorMessage(error));
					}.bind(this));
			}
		},
		processErrorMessage(error) {
			let errorMessage = null;

			this._.forEach(error['validation_errors'], function (message) {
				if (message.match("^Name \"(.+)\" is not unique\.$")) {
					errorMessage = this.$gettext('Název lokality musí být unikátní.');
					this.$refs['localitydetailformref'].$refs['nameref'].setForcedInvalid(true, this.$gettext('Název není unikátní'));
				}else if (message.match("^Prefix \"(.*)\" is in invalid format\!$")) {
					errorMessage = this.$gettext("IP prefix je zadán v neplatném formátu.");
					this.$refs['localitynewipprefixnameref'].setForcedInvalid(true, this.$gettext('Neplatný formát.'));
				}else if (message.match("^IP prefix \"(.*)\" is not unique for supplied operator\.$")) {
					errorMessage = this.$gettext("IP prefix není unikátní.");
					this.$refs['localitynewipprefixnameref'].setForcedInvalid(true, this.$gettext('IP prefix není unikátní.'));
				}else if (message.match("^Prefixes [0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\/[0-9]{1,3}, [0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\/[0-9]{1,3} are in collision\.$")) {
					errorMessage = this.$gettext("Zadaný IP prefix je v kolizi s jiným záznamem.");
					this.$refs['localitynewipprefixnameref'].setForcedInvalid(true, this.$gettext('IP prefix je v kolizi.'));
				}else if (message === "Weight must be at least 1.") {
					errorMessage = this.$gettext("Váha musí být alespoň 1");
					this.$refs['localitycontentsourceweightref'].setForcedInvalid(true, this.$gettext('Váha musí být alespoň 1'));
				}else if (message==="Weight should be a number.") {
					errorMessage = this.$gettext("Váha musí být číslo.");
					this.$refs['localitycontentsourceweightref'].setForcedInvalid(true, this.$gettext('Váha musí být číslo.'));
				}else if (message.match("^Missing required attribute - ")) {
					errorMessage = this.$gettext("Vyplňte povinné položky.");
					if(message.match('data.weight')) {
						this.$refs['localitycontentsourceweightref'].setForcedInvalid(true);
					}
					if(message.match('data.id_content_source')) {
						this.$refs['localitycontentsourceidref'].setForcedInvalid(true);
					}
					if(message.match('data.ip_prefix')) {
						this.$refs['localitynewipprefixnameref'].setForcedInvalid(true);
					}
					if(message.match('data.id_operator')) {
						this.$refs['localitynewipprefixoperatorref'].setForcedInvalid(true);
					}
				}else{
					errorMessage = message;
				}
			}.bind(this))

			return error['error_message'] = errorMessage || error['error_message'];
		},
	}
}



// WEBPACK FOOTER //
// ./src/components/views/localities/mixins/localities.js